module.exports = __webpack_public_path__ + "static/media/impreza-pcd.0242baa9.webp";